import { isLoadedWithEngageDomain } from './isLoadedWithEngageDomain';
import { isLoadedWithGlammerDomain } from './isLoadedWithGlammerDomain';

export type IsLoadedWithGlammerOrEngageDomain = () => boolean;
export const isLoadedWithGlammerOrEngageDomain: IsLoadedWithGlammerOrEngageDomain = () =>
  isLoadedWithGlammerDomain() || isLoadedWithEngageDomain();
